import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "NaN does not equal NaN",
  "description": "",
  "published": "2011-09-27T00:00:00.000Z",
  "redirect_from": ["/blog/nan-does-not-equal-nan/swizec/2517"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the second time today I noticed someone on twitter berating javascript over this little connundrum:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`> NaN == NaN
false
> NaN === NaN
false
> NaN !== NaN
true
>
`}</code></pre>
    <p>{`Counterintuitively, it would seem that NaN does not equal NaN. But let's think about this for a second. Is it really that strange or just a symptom of what the logical symbol NaN actually stands for?`}</p>
    <p>{`Thing is, NaN stands for "Not a Number" and if memory serves comes right out of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/IEEE_754-2008",
        "title": "IEEE 754-2008"
      }}>{`IEEE754`}</a>{` `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Floating_point",
        "title": "Floating point"
      }}>{`floating point arithmetic`}</a>{`. It's very handy for representing things like 0/0, different kinds of infinity and operations involving infinities. In short, it represents an `}<em parentName="p">{`undefinable number`}</em>{`.`}</p>
    <p>{`Now, what could possibly be the result of comparing two undefinable numbers?`}</p>
    <p>{`Mathematically, I have no idea what the result should be ... probably something we simply agreed upon? Like how the 0th power is 1. But in my naive understanding of these things it should produce random results. However, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/JavaScript",
        "title": "JavaScript"
      }}>{`JavaScript`}</a>{` is kind enough to always claim that NaN does not equal NaN, if for naught else than to remind us we are trying to do something stupid.`}</p>
    <p>{`Can anyone tell me if other languages handle this differently? Just produce an error of some sort?`}</p>
    <p>{`Also, please share this post with your local JavaScript newbie, I die a little every time I see that sort of tweet.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fef0bbc6-0acd-4e80-b24d-0faea5e230f1",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      